// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для личного кабинета преподавателя */
.personal-cabinet {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.personal-info-main {
  margin-top: -20px;
  display: flex;
  gap: 24px;
  align-items: stretch;
}

.personal-info-section {
  background: #f8f9ff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e0e7ff;
  flex: 1 1;
  min-height: 100px;
  display: flex;
  flex-direction: column;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 24px;
}

.info-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  min-width: 120px;
  text-align: left;
}

.info-value {
  font-size: 16px;
  color: #002fa7;
  font-weight: 600;
  flex: 1 1;
}

.buttons-row {
  display: flex;
  gap: 24px;
}

.section-button {
  flex: 1 1;
  background: white;
  border: 1px solid #002FA7;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  color: #002FA7;
}

.section-button:hover:not(:disabled) {
  background: #002FA7;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

.section-button:active:not(:disabled) {
  transform: translateY(0);
}

.section-button:disabled {
  background: #e2e8f0;
  border-color: #cbd5e1;
  color: #64748b;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.disciplines-section {
  background: #f8f9ff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e0e7ff;
}

.disciplines-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  display: block;
  margin-bottom: 12px;
}

.disciplines-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.discipline-item {
  background: white;
  border: 1px solid #e0e7ff;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  color: #002fa7;
  font-weight: 500;
  transition: all 0.3s ease;
}

.discipline-item:hover {
  background: #f0f4ff;
  border-color: #002FA7;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.1);
}

.discipline-item.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.discipline-item.clickable:hover {
  background: #f0f4ff;
  border-color: #002FA7;
  transform: translateX(5px);
}

.discipline-arrow {
  color: #002FA7;
  font-weight: bold;
  opacity: 0;
  transition: opacity 0.2s ease;
  margin-left: 10px;
}

.discipline-item.clickable:hover .discipline-arrow {
  opacity: 1;
}

/* Контейнер заголовка */
.cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

/* Общие стили для кнопок */
.header-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 2px solid #e2e8f0;
  color: #374151;
  padding: 12px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  height: 48px;
}

.header-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.header-btn:disabled {
  background: #f1f5f9;
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.info-icon-text {
  font-weight: 700;
  font-size: 16px;
  color: #002FA7;
}

.pc-refresh-icon {
  width: 22px;
  height: 22px;
  transition: transform 0.3s ease;
}

.pc-refresh-spin {
  animation: pc-spin 1s linear infinite;
}

@keyframes pc-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.info-icon-btn {
  position: relative;
  display: inline-flex;
  align-items: left;
}

.info-icon-btn:hover .info-tooltip,
.info-icon-btn:focus-within .info-tooltip {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(0%) translateY(8px);
}

.info-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  transform: translateX(0%) translateY(10px);
  background: white;
  border: 2px solid #e0e7ff;
  border-radius: 12px;
  padding: 20px;
  width: 320px;
  max-width: calc(100vw - 40px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

/* Адаптивность для мобильных */
@media (max-width: 768px) {
  .info-tooltip.small {
    width: calc(100% - 32px);
    left: 16px;
    right: 16px;
  }
}

.info-tooltip-content {
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
  white-space: normal;
}

/* Стрелка тултипа */
.info-tooltip::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 4px;
  transform: rotate(45deg);
  width: 12px;
  height: 12px;
  background: white;
  border-left: 2px solid #e0e7ff;
  border-top: 2px solid #e0e7ff;
}

.usage-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.steps {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.steps-number {
  width: 24px;
  height: 24px;
  background: #002FA7;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 47, 167, 0.2);
}

.steps span:last-child {
  font-size: 13px;
  line-height: 1.4;
  font-weight: 500;
}

@media (max-width: 480px) {
  .info-tooltip {
    width: 95vw;
    padding: 12px;
    left: 0;
    transform: translateY(8px);
    margin-left: 0;
  }
  
  .info-tooltip::before {
    left: 20px;
  }
  
  .info-tooltip-content {
    font-size: 13px;
  }
}

/* Стили для модальных окон */
.pc-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.lk-pc-modal {
  background: white;
  border-radius: 16px;
  width: 480px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: modal-appear 0.3s cubic-bezier(0.34, 1.2, 0.64, 1);
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.pc-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: linear-gradient(135deg, #002FA7 0%, #1a45c9 100%);
  color: white;
}

.pc-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.pc-modal-close {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: white;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  transition: all 0.2s ease;
  font-weight: 400;
  line-height: 1;
}

.pc-modal-close:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
}

.pc-modal-content {
  padding: 24px;
}

.pc-form-group {
  margin-bottom: 20px;
}

.pc-form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #1f2937;
  font-size: 14px;
}

.pc-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 14px;
  transition: all 0.2s ease;
  background-color: #f9fafb;
  box-sizing: border-box;
  font-family: inherit;
}

.pc-input:focus {
  outline: none;
  border-color: #002FA7;
  background-color: white;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.pc-input::placeholder {
  color: #9ca3af;
}

.pc-modal-actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 28px;
}

.pc-confirm-btn {
  padding: 12px 28px;
  background: linear-gradient(135deg, #002FA7 0%, #1a45c9 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  font-family: inherit;
}

.pc-confirm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.pc-confirm-btn:active:not(:disabled) {
  transform: translateY(0);
}

.pc-confirm-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Стили для красивого уведомления об успехе */
.lk-success-notification {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 1001;
  animation: slideInRight 0.3s cubic-bezier(0.34, 1.2, 0.64, 1);
}

.lk-success-content {
  background: white !important;
  color: #1f2937 !important;
  padding: 16px 20px;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 320px;
  border: 2px solid #002FA7 !important;
  background-image: none !important;
}

.lk-success-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #002FA7 0%, #1a45c9 100%) !important;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.lk-success-icon svg {
  color: white;
  width: 20px;
  height: 20px;
  stroke: white;
}

.lk-success-text {
  flex: 1 1;
}

.lk-success-title {
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 2px;
  color: #002FA7 !important;
}

.lk-success-message {
  font-size: 13px;
  color: #6b7280 !important;
}

.lk-success-close {
  background: #f3f4f6;
  border: none;
  border-radius: 10px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.lk-success-close:hover {
  background: #e5e7eb;
  color: #374151;
  transform: scale(1.05);
}

.lk-success-close svg {
  width: 14px;
  height: 14px;
}

/* Анимация появления уведомления */
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Анимация исчезновения уведомления */
@keyframes slideOutRight {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(100%);
  }
}

/* Для скрытия уведомления */
.pc-success-notification.hiding {
  animation: slideOutRight 0.3s ease-in forwards;
}

/* Адаптивность для уведомлений */
@media (max-width: 480px) {
  .pc-success-notification {
    top: 10px;
    right: 10px;
    left: 10px;
  }
  
  .pc-success-content {
    min-width: auto;
    width: 100%;
  }
}

.pc-error-message {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  color: #dc2626;
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
  border-left: 4px solid #dc2626;
  border: 1px solid #fecaca;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1);
}

/* Адаптивность для десктопа и планшетов */
@media (max-width: 768px) {
  .personal-cabinet {
    gap: 20px;
  }
  
  .personal-info-main {
    flex-direction: column;
    gap: 20px;
  }
  
  .personal-info-section,
  .disciplines-section {
    padding: 20px;
    min-height: auto;
  }
  
  .info-item {
    gap: 12px;
  }
  
  .info-label {
    min-width: 100px;
    font-size: 13px;
  }
  
  .info-value {
    font-size: 15px;
  }
  
  .buttons-row {
    flex-direction: column;
    gap: 12px;
  }
  
  .pc-modal {
    margin: 20px;
    max-height: calc(100vh - 40px);
  }
  
  .pc-modal-actions {
    flex-direction: column;
  }
  
  .pc-confirm-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .personal-cabinet {
    gap: 16px;
  }
  
  .personal-info-section,
  .disciplines-section {
    padding: 16px;
  }
  
  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .info-label {
    min-width: auto;
    font-size: 12px;
  }
  
  .info-value {
    font-size: 14px;
  }
  
  .discipline-item {
    padding: 10px 12px;
    font-size: 13px;
  }
  
  .section-button {
    padding: 10px 12px;
    font-size: 13px;
  }
}

/* Анимации */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.personal-info-main,
.disciplines-section {
  animation: fadeIn 0.5s ease-out;
}

.personal-info-main {
  animation-delay: 0.1s;
}

.disciplines-section {
  animation-delay: 0.2s;
}

/* Селектор режима логин / почта */
.credentials-mode-selector {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.credentials-mode-btn {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;
}

.credentials-mode-btn:hover {
  border-color: #002FA7;
  background: #f0f4ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);
}

.credentials-mode-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #002FA7 0%, #1a45c9 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 22px;
  font-weight: 500;
  flex-shrink: 0;
}

.credentials-mode-info h4 {
  margin: 0 0 4px 0;
  font-size: 16px;
  color: #111827;
  font-weight: 600;
}

.credentials-mode-info p {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}

/* Кнопка "Назад к выбору" - вторичная, неакцентная*/
.pc-secondary-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 28px;
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}

.pc-secondary-btn:hover {
  background: white;
  color: #002FA7;
  border-color: #002FA7;
  transform: translateY(-1px);
}

.pc-secondary-btn:active {
  transform: translateY(0);
}

.pc-secondary-btn svg {
  transition: transform 0.2s ease;
}

.pc-secondary-btn:hover svg {
  transform: translateX(-2px);
}


/* Стиль для подсказки */
.pc-form-hint {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}

/* Сообщение об ошибке */
.pc-error-message {
  background: #fef2f2;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 12px;
  margin-bottom: 20px;
  border-left: 3px solid #dc2626;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/th-components/PersonalCabinet.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,0CAA0C;EAC1C,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,uCAAuC;EACvC,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE;IACE,wBAAwB;IACxB,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,OAAO;IACP,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iDAAiD;EACjD,6DAA6D;AAC/D;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wEAAwE;EACxE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,4BAA4B;AAC5B;EACE,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,0CAA0C;AAC1C;EACE;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":["/* Стили для личного кабинета преподавателя */\n.personal-cabinet {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.personal-info-main {\n  margin-top: -20px;\n  display: flex;\n  gap: 24px;\n  align-items: stretch;\n}\n\n.personal-info-section {\n  background: #f8f9ff;\n  border-radius: 12px;\n  padding: 24px;\n  border: 1px solid #e0e7ff;\n  flex: 1;\n  min-height: 100px;\n  display: flex;\n  flex-direction: column;\n}\n\n.info-column {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  min-height: 24px;\n}\n\n.info-label {\n  font-size: 14px;\n  color: #666;\n  font-weight: 500;\n  min-width: 120px;\n  text-align: left;\n}\n\n.info-value {\n  font-size: 16px;\n  color: #002fa7;\n  font-weight: 600;\n  flex: 1;\n}\n\n.buttons-row {\n  display: flex;\n  gap: 24px;\n}\n\n.section-button {\n  flex: 1;\n  background: white;\n  border: 1px solid #002FA7;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n  color: #002FA7;\n}\n\n.section-button:hover:not(:disabled) {\n  background: #002FA7;\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n.section-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.section-button:disabled {\n  background: #e2e8f0;\n  border-color: #cbd5e1;\n  color: #64748b;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.disciplines-section {\n  background: #f8f9ff;\n  border-radius: 12px;\n  padding: 24px;\n  border: 1px solid #e0e7ff;\n}\n\n.disciplines-label {\n  font-size: 14px;\n  color: #666;\n  font-weight: 500;\n  display: block;\n  margin-bottom: 12px;\n}\n\n.disciplines-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.discipline-item {\n  background: white;\n  border: 1px solid #e0e7ff;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #002fa7;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.discipline-item:hover {\n  background: #f0f4ff;\n  border-color: #002FA7;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.1);\n}\n\n.discipline-item.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n}\n\n.discipline-item.clickable:hover {\n  background: #f0f4ff;\n  border-color: #002FA7;\n  transform: translateX(5px);\n}\n\n.discipline-arrow {\n  color: #002FA7;\n  font-weight: bold;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  margin-left: 10px;\n}\n\n.discipline-item.clickable:hover .discipline-arrow {\n  opacity: 1;\n}\n\n/* Контейнер заголовка */\n.cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n/* Общие стили для кнопок */\n.header-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 2px solid #e2e8f0;\n  color: #374151;\n  padding: 12px 24px;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n  height: 48px;\n}\n\n.header-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.header-btn:disabled {\n  background: #f1f5f9;\n  border-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.info-icon-text {\n  font-weight: 700;\n  font-size: 16px;\n  color: #002FA7;\n}\n\n.pc-refresh-icon {\n  width: 22px;\n  height: 22px;\n  transition: transform 0.3s ease;\n}\n\n.pc-refresh-spin {\n  animation: pc-spin 1s linear infinite;\n}\n\n@keyframes pc-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.info-icon-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: left;\n}\n\n.info-icon-btn:hover .info-tooltip,\n.info-icon-btn:focus-within .info-tooltip {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transform: translateX(0%) translateY(8px);\n}\n\n.info-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  transform: translateX(0%) translateY(10px);\n  background: white;\n  border: 2px solid #e0e7ff;\n  border-radius: 12px;\n  padding: 20px;\n  width: 320px;\n  max-width: calc(100vw - 40px);\n  box-shadow: 0 8px 25px rgba(0,0,0,0.15);\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n/* Адаптивность для мобильных */\n@media (max-width: 768px) {\n  .info-tooltip.small {\n    width: calc(100% - 32px);\n    left: 16px;\n    right: 16px;\n  }\n}\n\n.info-tooltip-content {\n  color: #374151;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  word-break: break-word;\n  white-space: normal;\n}\n\n/* Стрелка тултипа */\n.info-tooltip::before {\n  content: '';\n  position: absolute;\n  top: -6px;\n  left: 4px;\n  transform: rotate(45deg);\n  width: 12px;\n  height: 12px;\n  background: white;\n  border-left: 2px solid #e0e7ff;\n  border-top: 2px solid #e0e7ff;\n}\n\n.usage-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.steps {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.steps-number {\n  width: 24px;\n  height: 24px;\n  background: #002FA7;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n  box-shadow: 0 2px 4px rgba(0, 47, 167, 0.2);\n}\n\n.steps span:last-child {\n  font-size: 13px;\n  line-height: 1.4;\n  font-weight: 500;\n}\n\n@media (max-width: 480px) {\n  .info-tooltip {\n    width: 95vw;\n    padding: 12px;\n    left: 0;\n    transform: translateY(8px);\n    margin-left: 0;\n  }\n  \n  .info-tooltip::before {\n    left: 20px;\n  }\n  \n  .info-tooltip-content {\n    font-size: 13px;\n  }\n}\n\n/* Стили для модальных окон */\n.pc-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.lk-pc-modal {\n  background: white;\n  border-radius: 16px;\n  width: 480px;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: modal-appear 0.3s cubic-bezier(0.34, 1.2, 0.64, 1);\n}\n\n@keyframes modal-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.pc-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  background: linear-gradient(135deg, #002FA7 0%, #1a45c9 100%);\n  color: white;\n}\n\n.pc-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n}\n\n.pc-modal-close {\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: white;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  transition: all 0.2s ease;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.pc-modal-close:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: scale(1.05);\n}\n\n.pc-modal-content {\n  padding: 24px;\n}\n\n.pc-form-group {\n  margin-bottom: 20px;\n}\n\n.pc-form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #1f2937;\n  font-size: 14px;\n}\n\n.pc-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background-color: #f9fafb;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.pc-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  background-color: white;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.pc-input::placeholder {\n  color: #9ca3af;\n}\n\n.pc-modal-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 28px;\n}\n\n.pc-confirm-btn {\n  padding: 12px 28px;\n  background: linear-gradient(135deg, #002FA7 0%, #1a45c9 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n  font-family: inherit;\n}\n\n.pc-confirm-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.pc-confirm-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.pc-confirm-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Стили для красивого уведомления об успехе */\n.lk-success-notification {\n  position: fixed;\n  top: 24px;\n  right: 24px;\n  z-index: 1001;\n  animation: slideInRight 0.3s cubic-bezier(0.34, 1.2, 0.64, 1);\n}\n\n.lk-success-content {\n  background: white !important;\n  color: #1f2937 !important;\n  padding: 16px 20px;\n  border-radius: 16px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 320px;\n  border: 2px solid #002FA7 !important;\n  background-image: none !important;\n}\n\n.lk-success-icon {\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #002FA7 0%, #1a45c9 100%) !important;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.lk-success-icon svg {\n  color: white;\n  width: 20px;\n  height: 20px;\n  stroke: white;\n}\n\n.lk-success-text {\n  flex: 1;\n}\n\n.lk-success-title {\n  font-weight: 700;\n  font-size: 15px;\n  margin-bottom: 2px;\n  color: #002FA7 !important;\n}\n\n.lk-success-message {\n  font-size: 13px;\n  color: #6b7280 !important;\n}\n\n.lk-success-close {\n  background: #f3f4f6;\n  border: none;\n  border-radius: 10px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #6b7280;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.lk-success-close:hover {\n  background: #e5e7eb;\n  color: #374151;\n  transform: scale(1.05);\n}\n\n.lk-success-close svg {\n  width: 14px;\n  height: 14px;\n}\n\n/* Анимация появления уведомления */\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Анимация исчезновения уведомления */\n@keyframes slideOutRight {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n}\n\n/* Для скрытия уведомления */\n.pc-success-notification.hiding {\n  animation: slideOutRight 0.3s ease-in forwards;\n}\n\n/* Адаптивность для уведомлений */\n@media (max-width: 480px) {\n  .pc-success-notification {\n    top: 10px;\n    right: 10px;\n    left: 10px;\n  }\n  \n  .pc-success-content {\n    min-width: auto;\n    width: 100%;\n  }\n}\n\n.pc-error-message {\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\n  color: #dc2626;\n  padding: 16px;\n  border-radius: 8px;\n  margin: 16px 0;\n  border-left: 4px solid #dc2626;\n  border: 1px solid #fecaca;\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1);\n}\n\n/* Адаптивность для десктопа и планшетов */\n@media (max-width: 768px) {\n  .personal-cabinet {\n    gap: 20px;\n  }\n  \n  .personal-info-main {\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .personal-info-section,\n  .disciplines-section {\n    padding: 20px;\n    min-height: auto;\n  }\n  \n  .info-item {\n    gap: 12px;\n  }\n  \n  .info-label {\n    min-width: 100px;\n    font-size: 13px;\n  }\n  \n  .info-value {\n    font-size: 15px;\n  }\n  \n  .buttons-row {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .pc-modal {\n    margin: 20px;\n    max-height: calc(100vh - 40px);\n  }\n  \n  .pc-modal-actions {\n    flex-direction: column;\n  }\n  \n  .pc-confirm-btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .personal-cabinet {\n    gap: 16px;\n  }\n  \n  .personal-info-section,\n  .disciplines-section {\n    padding: 16px;\n  }\n  \n  .info-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n  \n  .info-label {\n    min-width: auto;\n    font-size: 12px;\n  }\n  \n  .info-value {\n    font-size: 14px;\n  }\n  \n  .discipline-item {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n  \n  .section-button {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n}\n\n/* Анимации */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.personal-info-main,\n.disciplines-section {\n  animation: fadeIn 0.5s ease-out;\n}\n\n.personal-info-main {\n  animation-delay: 0.1s;\n}\n\n.disciplines-section {\n  animation-delay: 0.2s;\n}\n\n/* Селектор режима логин / почта */\n.credentials-mode-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.credentials-mode-btn {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n  background: #f9fafb;\n  border: 2px solid #e5e7eb;\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  width: 100%;\n}\n\n.credentials-mode-btn:hover {\n  border-color: #002FA7;\n  background: #f0f4ff;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);\n}\n\n.credentials-mode-icon {\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, #002FA7 0%, #1a45c9 100%);\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 22px;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.credentials-mode-info h4 {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n  color: #111827;\n  font-weight: 600;\n}\n\n.credentials-mode-info p {\n  margin: 0;\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* Кнопка \"Назад к выбору\" - вторичная, неакцентная*/\n.pc-secondary-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 28px;\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.pc-secondary-btn:hover {\n  background: white;\n  color: #002FA7;\n  border-color: #002FA7;\n  transform: translateY(-1px);\n}\n\n.pc-secondary-btn:active {\n  transform: translateY(0);\n}\n\n.pc-secondary-btn svg {\n  transition: transform 0.2s ease;\n}\n\n.pc-secondary-btn:hover svg {\n  transform: translateX(-2px);\n}\n\n\n/* Стиль для подсказки */\n.pc-form-hint {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Сообщение об ошибке */\n.pc-error-message {\n  background: #fef2f2;\n  color: #dc2626;\n  padding: 12px 16px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  border-left: 3px solid #dc2626;\n  font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
